import {
  Flex,
  Text,
  TrendingUpIcon,
  VisuallyHidden,
} from '@buffer-mono/popcorn'

import type { DifferenceMode } from '../../graphqlEnums'

import styles from './MetricDifference.module.css'

import type { JSX } from 'react'

interface MetricDifferenceProps {
  difference: number | null | undefined
  differenceMode?: DifferenceMode
  size?: 'small' | 'medium'
}

export function formatDifference(diff: number, mode: DifferenceMode): string {
  if (mode === 'absolute') {
    const rounded = Math.round(Math.abs(diff)).toLocaleString()
    if (diff > 0) return `+${rounded}`
    if (diff < 0) return `-${rounded}`
    return '0'
  }
  const rounded = Number(Math.abs(diff).toFixed(1))
  if (diff > 0) return `+${rounded}%`
  if (diff < 0) return `-${rounded}%`
  return '0%'
}

export function MetricDifference({
  difference: rawDifference,
  differenceMode = 'percentage',
  size = 'medium',
}: MetricDifferenceProps): JSX.Element | null {
  const difference = rawDifference ?? 0
  const isPositive = difference > 0
  const isNegative = difference < 0

  if (!isPositive && !isNegative) return null

  const iconSize = size === 'small' ? 14 : undefined

  return (
    <Flex align="center" gap="2xs" className={styles.container}>
      {isPositive && (
        <TrendingUpIcon size={iconSize} color="success" aria-hidden />
      )}
      {isNegative && (
        <TrendingUpIcon
          size={iconSize}
          color="critical"
          className={styles.flipped}
          aria-hidden
        />
      )}
      <Text size="sm">
        <VisuallyHidden>{isPositive ? 'Up' : 'Down'} </VisuallyHidden>
        {formatDifference(difference, differenceMode)}
      </Text>
    </Flex>
  )
}
